import {
  recognitionValuesService,
  FetchRecognitionValuesRequest,
  RecognitionValuesResponse,
  useToast,
} from '@aslanpay/portal-common-lib';
import { useQuery } from '@tanstack/react-query';

const useFetchRecognitionValues = (params?: FetchRecognitionValuesRequest, enabled = true) => {
  const toast = useToast();

  return useQuery<RecognitionValuesResponse, Error>({
    queryKey: ['fetchRecognitionValues', params?.companyId, params?.isEnabled],
    queryFn: () => recognitionValuesService.fetchRecognitionValues(params),
    enabled,
    onError: () => {
      toast({
        position: 'top-right',
        status: 'error',
        title: 'Something went wrong',
        description: 'Failed to load recognition values. Please try again.',
      });
    },
  });
};

export default useFetchRecognitionValues;
